/**
 * Market Metrics Helper
 *
 * Provides utilities for fetching and formatting market-level statistics
 * from Athena's sellerDashboardMetrics service.
 */
import type { GetMarketMetricsQueryQuery } from '../__generated__/athena';
import { getAthenaClient } from '../components/api';

/**
 * Market metrics response containing current week's statistics
 */
export type MarketMetrics =
  GetMarketMetricsQueryQuery['sellerDashboardMetrics']['getMarketMetrics'];

/**
 * Fetches current market-level metrics for a given market identifier
 *
 * @param marketIdentifier - The market identifier (e.g., "atlanta", "phoenix", "dallas")
 * @returns Market metrics including homes sold, new listings, delistings, and week-over-week changes
 */
export async function getMarketMetrics(
  marketIdentifier: string,
): Promise<MarketMetrics | null | undefined> {
  const result = await getAthenaClient().GetMarketMetricsQuery({
    marketIdentifier,
  });

  return result?.sellerDashboardMetrics?.getMarketMetrics;
}
